import { render, staticRenderFns } from "./VueQrCode.vue?vue&type=template&id=c0b137d0&scoped=true"
import script from "./VueQrCode.vue?vue&type=script&lang=js"
export * from "./VueQrCode.vue?vue&type=script&lang=js"
import style0 from "./VueQrCode.vue?vue&type=style&index=0&id=c0b137d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b137d0",
  null
  
)

export default component.exports